module.exports = __webpack_public_path__ + "static/media/landing-page-cake-shop-image.d61887aa.webp";